// @ts-nocheck

import { useViewportContext } from '../contexts/ViewportContext';

export default ({ children }) => {
  const { fontSize } = useViewportContext();
  return children({ fontSize });
};
